import { useCallback, useEffect, useState } from 'react';
import { Col, Row } from 'reactstrap';

import {
  getPackageSections,
  getPackageTimeCalendar,
} from '../../../api/requests/sectionsMaintainer';
import { useLoadingState } from '../../../hooks/useLoadingState';
import PackagesViewSchedule from '../../../packages/parts/PackagesViewSchedule';
import { PackagesViewsSection } from '../../../types/packageTypes';
import { TimeModuleType } from '../../../types/timeModuleTypes';
import SectionDetailTable from './SectionDetailTable';

type SectionScheduleProps = {
  sectionId: number | string;
  packageId: number | undefined;
};

const SectionSchedule = ({ sectionId, packageId }: SectionScheduleProps) => {
  const [sections, setSections] = useState<PackagesViewsSection[] | null>(null);
  const [timeModules, setTimeModules] = useState<TimeModuleType[]>([]);
  const { setLoading, setErrorLoading } = useLoadingState();

  const getPackageInfo = useCallback(
    async (pkgId: number) => {
      setLoading(true);
      const { data, error } = await getPackageSections(sectionId, pkgId);

      if (data) {
        setSections(data);
      }
      if (error) {
        setErrorLoading(error.code);
      }
      setLoading(false);
    },
    [sectionId, setErrorLoading, setLoading],
  );

  const getTimeModules = useCallback(async () => {
    setLoading(true);
    const { data, error } = await getPackageTimeCalendar(sectionId);

    if (data) {
      setTimeModules(data);
    }
    if (error) {
      setErrorLoading(error.code);
    }
    setLoading(false);
  }, [sectionId, setErrorLoading, setLoading]);

  useEffect(() => {
    if (packageId) {
      getPackageInfo(packageId);
    } else {
      setSections(null);
    }

    if (timeModules.length === 0) {
      getTimeModules();
    }
  }, [getPackageInfo, getTimeModules, timeModules, packageId]);

  return (
    <>
      <Row className="pb-5">
        <Col xs={12} md={5} style={{ zIndex: 0 }}>
          <SectionDetailTable sections={sections} />
        </Col>
        <Col xs={12} md={7}>
          <PackagesViewSchedule timeModules={timeModules} sections={sections} />
        </Col>
      </Row>
    </>
  );
};

export default SectionSchedule;
